<script setup>
  import PatientinputComponentAutocomplete from "@pages/Patientinput/Components/Autocomplete.vue";
  import {coreRouter} from "@utils/coreRouter/coreRouter.js";

  defineOptions({
    name: "PatientinputMedicationSearch",
  });

  const props = defineProps({
    form: {
      type: Object,
      required: true,
    },
  });

  const searchPac = (searchTerm) => {
    // some scanners prepend a '#', which we have to remove
    if (searchTerm.charAt(0) === "#") {
      searchTerm = searchTerm.slice(1);
    }

    // A scanned "PZN" value starts with a '-', so if
    // we receive a searchTerm like '-12345678', we
    // strip off this '-' and search for the PZN.
    let match = searchTerm.match(/^-(\d{7,8})/i);
    if (match && match[1]) {
      // we just use the digits as PZN and do not
      // care if it is 7 or 8 digits long
      searchTerm = match[1];
    }

    return new Promise((resolve) => {
      coreRouter.searchPacForPatientinput(searchTerm, {
        onSuccess: (response) => {
          resolve(response.data);
        },
        onError: () => {
          resolve(false);
        },
      });
    });
  };

  const updateRowWithSelectedItem = (selectedFam) => {
    if (!props.form.medication.pzns.some((pzn) => Number.parseInt(pzn) === Number.parseInt(selectedFam.PZN))) {
      props.form.medication.pzns.push(selectedFam.PZN);
      props.form.medication.list.push(selectedFam);
    }
  };
</script>

<template>
  <PatientinputComponentAutocomplete
    placeholder="Bitte Name/PZN eingeben"
    :min-search-term-length="3"
    :fetch-method="searchPac"
    :test-id="getTestId('medication')"
    @selected="updateRowWithSelectedItem"
  >
    <template #autocomplete-item="{item}">
      <div class="min-h-10">
        <div class="flex justify-between">
          <div>{{ item.Name }} / {{ item.Packung }}</div>
        </div>

        <p class="text-sm leading-tight text-gray-500">{{ item.Anbieter }} / PZN: {{ item.PZN }}</p>

        <div
          v-if="form.medication.pzns.some((pzn) => parseInt(pzn) === parseInt(item.PZN))"
          class="text-sm text-mcred-500"
        >
          Artikel wurde bereits erfasst
        </div>
      </div>
    </template>
  </PatientinputComponentAutocomplete>
</template>
